import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatIconModule } from "@angular/material/icon";
import { EmailConfirmationBannerComponent } from "./email-confirmation-banner.component";
import { TranslocoModule } from "@ngneat/transloco";

@NgModule({
  declarations: [EmailConfirmationBannerComponent],
  imports: [CommonModule, MatIconModule, TranslocoModule],
  exports: [EmailConfirmationBannerComponent],
})
export class EmailConfirmationBannerModule {}
